import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading games..." @subtitle="Discovering games and their details for you" />
</template>
);
